import './style.css';

export const HeadingServices = ({ children, className = '' }) => {
  return <h2 className={`heading-services ${className}`}>{children}</h2>;
};
